import { IBrandingAction, IBrandingActions, IBrandingState, II18nMessages } from './models';
import { IChannel, IOfflineSchedule, IRequestItems, ITrackingLink } from '../../data/api/models';

const SET_I18N = 'app/branding/SET_I18N';
const SET_LOCALE = 'app/branding/SET_LOCALE';
const SET_CHANNEL = 'app/branding/SET_CHANNEL';
const SET_IS_OFFLINE = 'app/branding/SET_IS_OFFLINE';
const SET_TRACKING_LINK =  'app/branding/SET_TRACKING_LINK';
const SET_REQUEST_ITEM =  'app/branding/SET_REQUEST_ITEM';

const initialState: IBrandingState = {
  locale: 'en-GB',
  i18n: {},
  channel: null,
  isOffline: false,
  trackingLink: null,
  requestItems: null,
};

export function reducer(state: IBrandingState = initialState, action: IBrandingAction): IBrandingState {
  switch (action.type) {
    case SET_I18N:
      return {
        ...state,
        i18n: action.payload.i18n,
      };
    case SET_LOCALE:
      return {
        ...state,
        locale: action.payload.locale,
      };
    case SET_CHANNEL:
      return {
        ...state,
        channel: action.payload.channel,
      };
    case SET_TRACKING_LINK:
      return {
        ...state,
        trackingLink: action.payload.trackingLink,
        channel: {
          ...state.channel,
          phone: action.payload.trackingLink.phone,
        },
      };
    case SET_REQUEST_ITEM:
      return {
        ...state,
        requestItems: {
          ...state.requestItems,
          host: action.payload.requestItems.host,
          httpScheme: action.payload.requestItems.httpScheme,
        },
      };
    case SET_IS_OFFLINE:
      return {
        ...state,
        isOffline: action.payload.isOffline,
        offlineSchedule: action.payload.offlineSchedule,
      };
    default:
      return state;
  }
}

const setLocale = (locale: string): IBrandingAction => ({type: SET_LOCALE, payload: {locale}});
const setChannel = (channel: IChannel): IBrandingAction => ({type: SET_CHANNEL, payload: {channel}});
const setI18n = (i18n: II18nMessages): IBrandingAction => ({type: SET_I18N, payload: {i18n}});

const setIsOffline = (isOffline: boolean, offlineSchedule: IOfflineSchedule): IBrandingAction => ({
  type: SET_IS_OFFLINE,
  payload: { isOffline, offlineSchedule },
});

const setTrackingLink = (trackingLink: ITrackingLink) => ({ type: SET_TRACKING_LINK, payload: { trackingLink } });
const setRequestItems = (requestItems: IRequestItems) => ({ type: SET_REQUEST_ITEM, payload: { requestItems } });

const getProduct = () => (dispatch, getState) => {
  const { branding } = getState();

  return branding.channel.products[0];
};

export const actions: IBrandingActions = {
  setLocale,
  setI18n,
  setChannel,
  getProduct,
  setIsOffline,
  setTrackingLink,
  setRequestItems,
};
